import React from 'react'
import { MessageProps, useChannelStateContext, MessageProvider, useMessageContext, useChatContext } from 'stream-chat-react'
import { View, Icon, Text } from '@/components'
import { createStyles } from '@codeleap/styles'
import { textVariant } from '@/config'
import { ChatMessageWithContext } from '../../ChatMessage'
import { useMessageGrouping } from '@packages/chat'
import { Channel } from 'stream-chat'

const ThreadStart = () => {
  const { thread } = useChannelStateContext('ThreadStart')
  const replyCount = thread.reply_count

  return (
    <View style={styles.repliesWrapper}>
      {replyCount > 0 ? <Text text={`${replyCount} replies`} style={styles.repliesText} /> : (
        <View style={['row', 'alignCenter', 'gap:0.5']}>
          <Icon name='message-text-circle-02' style={styles.replyIcon} />
          <Text text={`Reply in thread`} style={styles.repliesText} />
        </View>
      )}
    </View>
  )
}

const ThreadHeadMessage = ({ channel }: { channel: Channel }) => {
  const messageProps = useMessageContext()
  const { lastGroupMessage, firstGroupMessage } = useMessageGrouping({ groupStyles: messageProps.groupStyles, message: messageProps.message })

  return (
    <ChatMessageWithContext
      {...messageProps}
      threadList={true}
      channel={channel}
      firstGroupMessage={firstGroupMessage}
      lastGroupMessage={lastGroupMessage}
    />
  )
}

export const ThreadHead = (props: MessageProps) => {
  const { channel } = useChannelStateContext()
  const { client } = useChatContext()

  const isMyMessage = typeof props?.isMyMessage === 'function'
    ? props.isMyMessage
    : () => props?.message?.user?.id === client?.userID

  return (
    <div className='str-chat__parent-message-li'>
      <MessageProvider value={{ ...props, isMyMessage, initialMessage: true, threadList: true }}>
        <ThreadHeadMessage channel={channel} />
      </MessageProvider>
      <ThreadStart />
    </div>
  )
}

const styles = createStyles(theme => ({
  wrapper: {
    ...theme.spacing.padding(3),
  },
  repliesWrapper: {
    ...theme.border({
      directions: ['top', 'bottom'],
      color: 'neutralSolid300',
    }),
    ...theme.spacing.paddingVertical(1),
    marginHorizontal: -theme.spacing.value(3),
    ...theme.spacing.paddingHorizontal(3),
  },
  repliesText: {
    ...textVariant(['c1', 'medium']),
    color: theme.colors.textHeadingHighlighted,
  },
  replyIcon: {
    ...theme.sized(2.5),
    color: theme.colors.textHeadingHighlighted,
  },
}))
